import { css } from 'styled-components'
import { ThemedComponentProps } from '../theme.types'

export const transitionDuration = (props: ThemedComponentProps) => props.theme.transitionDuration

export const transitions = (elements: Array<string>, duration = 1) =>
  css`
    transition: ${props => elements.map(property => `${property} ${transitionDuration(props) * duration}ms ease-out`).join(', ')};
  `
